import React from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import utils from '../../../../../components/Organisms/Form/utils'
import globalConsts from '../../globalConsts'
import InputFilesGroup from 'src/views/Forms/Components/InputFilesGroup/InputFilesGroup'
import { INDIVIDUAL_SEND_FILE_URL } from 'src/views/Pages/Onboarding/flowConfig'
import { NonUSpersonsText, clientDocumentationLink } from '../IndividualAccountOpeningDocumentation/config'
import Label from 'src/components/Atoms/Label/Label'

const LabelNameInfo = (
  <Label
    key='LabelNameInfo'
    label={t('onboarding.forms.IndividualAccount.OpeningTradingAccountForm.visualOnly.labelNameInfo')}
    gridArea='labelNameInfo'
    removeEllipsis
    fontMarginTop='-8px'
    fontMarginBottom='32px'
  />
)

const config = utils.injectTranslation({
  id: 'OpeningTradingAccountForm',
  path: 'onboarding.forms.IndividualAccount.OpeningTradingAccountForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
      },
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'investingOwnMoney',
            minHeight: '0',
            margin: '0',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'investingOwnMoney1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'investingOwnMoney2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'investmentDetails',
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateAreas:
                  '\'accountType nameOfJointAccountHolder\' \'. labelNameInfo\'',
      },
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'accountType',
            minHeight: '0',
            margin: '0',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'accountType1',
                label: t('onboarding.forms.IndividualAccount.OpeningTradingAccountForm.inputs.accountType.field2opt1'),
                value: 'individual',
              },
              {
                id: 'accountType2',
                label: t('onboarding.forms.IndividualAccount.OpeningTradingAccountForm.inputs.accountType.field2opt2'),
                value: 'jointAccount',
              },
            ],
            gridArea: 'accountType',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'nameOfJointAccountHolder',
            minHeight: '0',
            marginBottom: '0',
            gridArea: 'nameOfJointAccountHolder',
            required: true,
          },
        },
        // @ts-ignore:next-line
        {
          visualComponent: LabelNameInfo,
          visualName: 'labelNameInfo'
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
      },
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'areYouSucdenEmployee',
            minHeight: '0',
            margin: '0',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'areYouSucdenEmployee1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'areYouSucdenEmployee2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'nameOfEmployee',
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
      },
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'employeeOfOtherInvestmentCompany',
            minHeight: '0',
            margin: '0',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'employeeOfOtherInvestmentCompany1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'employeeOfOtherInvestmentCompany2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'nameOfTheCompany',
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isUSPerson',
            minHeight: '0',
            margin: '16px 0 16px 0',
            dataList: [
              {
                id: 'isaUSPerson1',
                label: t('components.forms.labels.yes'),
                value: 'true',
                required: true
              },
              {
                id: 'isaUSPerson2',
                label: t('components.forms.labels.no'),
                value: 'false',
                required: true
              },
            ],
            required: true
          },
        },
        {
          componentType: '',
          visualComponent: NonUSpersonsText,
          visualName: 'nonUsPersonText'
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isUSProducts',
            margin: '0 0 8px 4%',
            marginBottom: '0',
            minHeight: '0',
            dataList: [
              {
                id: 'isUSProducts1',
                label: t('components.forms.labels.yes'),
                value: 'true',
                required: true
              },
              {
                id: 'isUSProducts2',
                label: t('components.forms.labels.no'),
                value: 'false',
                required: true
              },
            ],
            required: true
          },
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_FORMW8BEN,
            required: true
          },
          custom: props => InputFilesGroup({
            margin: '0 0 0 8%',
            inputMargin: '0 0 24px 0',
            width: '92%',
            inputLabel: t('onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.files.formW8BEN.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: INDIVIDUAL_SEND_FILE_URL
              }
            },
            step: '6',
            name: globalConsts.INPUT_FILES_FORMW8BEN,
            itemKey: 'w8ben',
            ...props
          }),
          visualName: 'w8ben-fileInput'
        },
        {
          componentType: 'input',
          props: {
            name: 'formW9',
            required: true
          },
          custom: props => InputFilesGroup({
            margin: '0 0 0 4%',
            inputMargin: '16px 0 24px 0',
            width: '96%',
            // @ts-ignore:next-line
            groupLabel: <Trans i18nKey={'onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.files.formW9.groupLabel'} components={{ clientDocumentationLink }}/>,
            inputLabel: t('onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.files.formW9.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: INDIVIDUAL_SEND_FILE_URL
              }
            },
            step: '6',
            name: 'formW9',
            itemKey: 'w9',
            ...props
          }),
          visualName: 'w9-fileInput'
        },
      ]
    }
  ],
})

export default config
